module.exports = __webpack_public_path__ + "img/output-onlinegiftools (36).eac065ba.gif";